import { useState } from 'react'
// Ant Design
import { Flex, Typography, Pagination, message, Spin } from 'antd'
// Config
import { getConfig } from '../../config'
const { Title, Text } = Typography

export const ListReport = ({ t, reports, views, setViews, setReports, page, setPage, total, loading }) => {
    const [animatedReport, setAnimatedReport] = useState(null);
    const [messageApi, contextHolder] = message.useMessage()

    const addGraph = (report) => {
        if(views.length >= 10) {
            return messageApi.info(t("max_graphs_reached"))
        }
        
        setViews([...views, report])

        setAnimatedReport(report.report_name);

        setTimeout(() => {
            const newReports = reports.filter(item => item.report_name !== report.report_name)
            setReports(newReports)
            setAnimatedReport(null)
        }, 500);
    }

    return (
        <Flex vertical style={{ width: "25%", height: "100%" }}>
            <Flex style={{ width: "100%", height: "32px", borderBottom: `1.5px solid ${getConfig("colorPrimario")}` }}>
                <Title level={5} style={{ color: getConfig("colorPrimario") }}>{t("select_option")}</Title>
            </Flex>

            {loading ?
                <Flex justify="center" style={{ width: "100%", marginTop: "20px" }}>
                    <Spin style={{ color: getConfig("colorPrimario") }} />
                </Flex>
                :
                <Flex vertical style={{ position: "relative", width: "100%", height: "calc(100% - 32px)", overflowY: "auto", overflowX: "hidden" }}>
                    {reports.map((report) => (
                        <Flex
                            key={report.report_name}
                            onClick={() => addGraph(report)}
                            justify="center"
                            align="center"
                            style={{ width: "100%", minHeight: "40px", backgroundColor: "#393E3E", marginTop: "10px", borderRadius: "10px", cursor: "pointer" }}
                            className={animatedReport === report.report_name ? "animate__animated animate__fadeOutRight" : ""}
                        >
                            <Text style={{ color: "#fff", fontSize: "14px", textAlign: "center"  }}>{report.report_name}</Text>
                        </Flex>
                    ))}

                    <Flex justify="center" style={{ position: "sticky", width: "101%", bottom: 0, left: 0, backgroundColor: "#fff", zIndex: "1" }}>
                        <Pagination 
                            simple={{ readOnly: true }}
                            current={page} 
                            onChange={(newPage) => setPage(newPage)} 
                            total={total}
                            pageSize={10}
                            showSizeChanger={false}
                        />
                    </Flex>
                </Flex>
            }

            {contextHolder}
        </Flex>
    )
}